import { Box, Typography } from '@mui/material';
import { AddSourceButton, SourcesSection } from './SourcesSection';

/**
 * `/admin/repositories` — the git repositories the Agent Skill library imports. Each is read for
 * new release tags every night, and Sync reads one now.
 */
export const AdminRepositoriesPage = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h1" component="h1">
        Repositories
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 720 }}>
        Repositories whose Agent Skills are imported into the library. Each is read for new release tags every
        night. Press Sync to read one now.
      </Typography>
    </Box>

    <Box>
      <AddSourceButton />
    </Box>
    <SourcesSection />
  </Box>
);
